import * as React from 'react'
import styled from 'styled-components'
import EnergyLabelTemplate from 'theme/atoms/EnergyLabel'
import { CartItem } from 'hooks/account/types'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'

type Props = {
  item: CartItem
}

export function EnergyLabel(props: Props) {
  const t = useTranslations<'molecules-account-CartItem'>()
  const showEnergyModalRef = React.useRef<() => void>(() => null)

  if (!props.item.attributes?.ENERGY_EFFICIENCY_CLASS) return null

  return (
    <Wrapper className="EnergyLabel" data-cy-state="show-energy-label">
      <EnergyLabelTemplate
        data-cy-handle="open-energy-label-modal"
        energyLabelLink={
          props.item.attributes.ENERGY_LABEL?.values[0].document || null
        }
        label={
          (props.item.attributes.ENERGY_EFFICIENCY_CLASS?.values[0].value ||
            '') as string
        }
        size="tiny"
        openModalRef={showEnergyModalRef}
      />
      <div
        className="label"
        data-cy-handle="close-energy-label"
        onClick={() => showEnergyModalRef.current()}
      >
        {t('energylabel_product_data_sheet')}
      </div>
    </Wrapper>
  )
}

export default EnergyLabel

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing('xs')};
  > .label {
    ${theme.ty('r-xs', null, 'r-s')}
    color: ${theme.colors.shade.b2};
    text-decoration: underline;
    cursor: pointer;
  }
`
